// ─────────────────────────────────────────────────────────────────────────────
// Static fallback constants — used when the store/config API is unavailable.
// Live values are fetched via getStoreCompanyInfo() in serverProps.js.
// ─────────────────────────────────────────────────────────────────────────────

import { EMAIL_SUPPORT } from './env';

export const companyName      = 'Ennix Electronics Private Limited';
export const companyShortName = 'Ennix';
export const website          = 'https://ennixelectronics.com';

const downloadBrochure = 'https://ennixelectronics.com/sample.pdf';
const enquiry          = '9211843332';

export const contacts = {
    support:        `+91-${enquiry}`,
    emailSupport:   EMAIL_SUPPORT,
    enquiry:        `+91-${enquiry}`,
    landline:       '+91-120-4136569',
    homeAutomation: '+91-9891320534',
    whatsappUrl:    `https://wa.me/${enquiry}?text=${encodeURIComponent('Hi')}`,
};

// Fallback addresses (mirrors the seed data in API-Backend)
export const addresses = [
    {
        label:       'Corporate Office',
        companyName: 'Ennix Electronics Private Limited',
        address:     'GH-03C, Greater Noida W Rd, Greater Noida, Uttar Pradesh 201301',
        mobile:      ['+91-9211843332'],
        phone:       ['+91-120-4136569'],
        email:       'info@ennixelectronics.com',
    },
    {
        label:       'Store Address',
        companyName: 'Ennix Electronics Private Limited',
        address:     'House No: 60, First Floor, Roza Yakubpur, Sector 16B, Near Tyagi Barat Ghar, Greater Noida West, Gautam Budh Nagar, Uttar Pradesh 201318',
        mobile:      ['9956984277'],
        phone:       ['01204260913'],
        email:       'support@ennixelectronics.com',
    },
];

export const logo = {
    amazon:  '/images/amazon.webp',
    flipkart: '/images/flipkart.webp',
    company: '/images/ennix-logo.webp',
    companyIcon: '/icon-logo.png',

};

export const FooterText = `${companyName}. All Rights Reserved`;

export const doDownloadBrocher = () => {
    const link = document.createElement('a');
    link.href     = downloadBrochure;
    link.download = `${companyShortName}_Smart_Brochure.pdf`;
    link.target   = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const socialMedia = {
    facebook:  { icon: 'pi pi-facebook',  url: 'https://www.facebook.com/ennixelectronics' },
    instagram: { icon: 'pi pi-instagram', url: 'https://www.instagram.com/ennixelectronics' },
    whatsapp:  { icon: 'pi pi-whatsapp',  url: contacts.whatsappUrl },
    linkedin:  { icon: 'pi pi-linkedin',  url: 'https://www.linkedin.com/company/ennixelectronics' },
    twitter:   { icon: 'pi pi-twitter',   url: 'https://x.com/home' },
    youtube:   { icon: 'pi pi-youtube',   url: 'https://www.youtube.com/@EnnixElectronics' },
};

export const bannerBottomInfoTitle      = "Facing issues with your IoT or smart device? Our professionals are here to help — don't hesitate to contact us!";
export const getInTouchDetailsScreen    = "If you have any questions or require any further assistance, please don't hesitate to reach out to our customer support team or to write email directly. We are here to address any concerns you may have and provide you with the support you need.";
export const supportLink                = '/support';

export const ecomercePlatfromList = {
    amazon: {
        id:    'buy-1',
        title: 'Amazon',
        logo:  logo?.amazon,
        url:   'https://www.amazon.in/stores/ENNIX/page/DD8E736E-9B54-46AE-BF92-DEB6D96A07D4',
    },
    flipkart: {
        id:    'buy-2',
        title: 'Flipkart',
        logo:  logo?.flipkart,
        url:   'https://www.flipkart.com/store/ennix',
    },
};

export const smartLifeAppLinks = {
    ios:     'https://apps.apple.com/us/app/smart-life-smart-living/id1115101477',
    android: 'https://play.google.com/store/apps/details?id=com.tuya.smartlife&hl=en_IN',
};

export const appConfig = {
    title:            companyName,
    companyName,
    appShortName:     companyShortName,
    downloadBrochure,
    contacts,
    addresses,
    logo,
    socialMedia,
    bannerBottomInfoTitle,
    smartLifeAppLinks,
};
